import { render } from "./TransactView.vue?vue&type=template&id=f212c746"
import script from "./TransactView.vue?vue&type=script&lang=js"
export * from "./TransactView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__